import { MetricCardContainer, MetricLabel, MetricValue, ValueContainer } from './MetricCard.styles';
import { motion } from 'framer-motion';

const MetricCard = ({ metric, violations, handleOnchangeFilter, isActive }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 3 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
      <MetricCardContainer active={isActive ? 'true' : null} onClick={() => handleOnchangeFilter(metric.type)}>
        <ValueContainer>
          <MetricValue>{violations?.count || 0}</MetricValue>
        </ValueContainer>
        <MetricLabel type={metric.type} variant="navBar">
          {metric.label}
        </MetricLabel>
      </MetricCardContainer>
    </motion.div>
  );
};

export default MetricCard;
